import { render, staticRenderFns } from "./VerticalSlotsMachine.vue?vue&type=template&id=1210942a&scoped=true&"
import script from "./VerticalSlotsMachine.vue?vue&type=script&lang=js&"
export * from "./VerticalSlotsMachine.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSlotsMachine.vue?vue&type=style&index=0&id=1210942a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210942a",
  null
  
)

export default component.exports